import styles from "./LimitPrice.module.css"
const LimitPrice = (props) => {
    const { disable, field_Id, handleAllowedButton} = props

  return (
      <div className={styles.token_amount}>
          <div className={styles.token_info}>
              <span>Price:</span>
              <div>
                  <span>Denomination</span>
                  <span>ETH</span>
                  <span>USDC</span>
              </div>
          </div>
    <input
      id={`limit-price-quantity`}
      className={styles.limit_quantity}
      onChange={() => handleAllowedButton()}
     
      type='text'
      inputMode='decimal'
      autoComplete='off'
      autoCorrect='off'
      min='0'
      minLength='1'
      pattern='^[0-9]*[.,]?[0-9]*$'
      placeholder='0.0'
      disabled={disable}
      required
    />
  </div>
  )
}

export default LimitPrice